import type { SizesString } from '@/app/components/media/app-image/shared/image-size-types';

export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_ID = 'exterior-threesixty';

export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LABELS = {
  label: 'มุมมอง 360°',
  back: 'กลับ',
  backAriaLabel: 'กลับสู่ส่วนภายนอก',
  drag: 'ลาก',
  guide: 'ลากซ้าย-ขวา เพื่อดูรอบคัน',
  loading: 'กำลังเตรียม<span>มุมมอง 360°</span>',
  loadError: 'ไม่สามารถโหลดมุมมอง 360° ได้',
  retry: 'ลองอีกครั้ง',
  viewer: 'ลากหรือใช้ลูกศรซ้ายขวาเพื่อหมุนรถ',
  presetViews: 'เลือกมุมมองรถ',
  presets: ['มุมด้านหน้า', 'มุมด้านข้าง', 'มุมด้านท้าย'],
} as const;

export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_CONCURRENCY = 8;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MOBILE_CONCURRENCY = 2;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_COMPLETE_DESKTOP_CONCURRENCY = 4;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_COMPLETE_MOBILE_CONCURRENCY = 3;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_BOOTSTRAP_CONCURRENCY = 4;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_IDLE_CONCURRENCY = 2;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PREVIEW_CONCURRENCY = 2;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PREVIEW_FRAME_QUALITY = 75;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PREVIEW_SHARP_FRAME_QUALITY = 95;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_INTERACTIVE_FRAME_QUALITY = 75;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_SHARP_FRAME_QUALITY = 95;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_THUMBNAIL_QUALITY = 75;
/** Image slot inside the preset button: item max width minus 8px of border and padding. */
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PRESET_THUMBNAIL_SIZES =
  '(min-width: 768px) 156px, (min-width: 480px) 126px, 96px' as const satisfies SizesString;

export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PRESET_THUMBNAIL_DESKTOP_SIZES =
  '156px' as const satisfies SizesString;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MAX_HIGH_PRIORITY_REQUESTS = 2;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MAX_CACHED_FRAME_COUNT = 48;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MOBILE_MAX_CACHED_FRAME_COUNT = 32;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PREFETCH_AHEAD_FRAME_COUNT = 24;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PREFETCH_BEHIND_FRAME_COUNT = 8;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_IDLE_PREFETCH_RADIUS = 16;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_READY_WINDOW_RADIUS = 8;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MIN_READY_FRAME_COUNT = 17;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MAX_RETRIES = 1;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LOAD_TIMEOUT_MS = 10000;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_COMPLETE_LOAD_TIMEOUT_MS = 120000;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_LOADING_GRACE_MS = 150;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_SHARP_FRAME_DEBOUNCE_MS = 200;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_FORCE_LOADING_QUERY_PARAM =
  'force360Loading';
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_FORCE_ERROR_QUERY_PARAM =
  'force360Error';
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_REFERENCE_FRAME_COUNT = 151;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MOBILE_FRAME_COUNT = 100;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_DEFAULT_PIXELS_PER_FRAME = 6;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MOUSE_PIXELS_PER_FRAME = 7;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_TOUCH_PIXELS_PER_FRAME = 6;

export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PREVIEW_ROTATION_DEGREES = 60;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_PREVIEW_MAX_FRAME_COUNT = 32;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_STRETCH_PIXEL_DELAY_MS = 100;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_STRETCH_PIXEL_DURATION_MS = 1400;

export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_RETURN_SHORT_BASE_DURATION_MS = 140;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_RETURN_SHORT_FRAME_DURATION_MS = 20;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_RETURN_BASE_DURATION_MS = 180;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_RETURN_FRAME_DURATION_MS = 10;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_RETURN_MAX_DURATION_MS = 600;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_RETURN_EXACT_FRAME_TIMEOUT_MS = 3000;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_OPEN_HANDOFF_DURATION_MS = 480;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_HANDOFF_DURATION_MS = 420;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_HANDOFF_EASING =
  'cubic-bezier(0.22, 1, 0.36, 1)';
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MOBILE_MEDIA_QUERY =
  '(max-width: 1023px)';
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MOBILE_PORTRAIT_MEDIA_QUERY =
  '(max-width: 767px) and (orientation: portrait)';
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_OPEN_REVEAL_CLIP_PATHS = {
  default: 'inset(25% 25% 25% 25%)',
  'mobile-portrait': 'inset(40% 8% 40% 8%)',
} as const;
export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_OPEN_REVEAL_VISIBLE_CLIP_PATH =
  'inset(0% 0% 0% 0%)';

export const SPARTAN_PRODUCT_EXTERIOR_THREESIXTY_MEDIA_CLASS_NAME =
  'aspect-5/4 w-full';
